<template>
  <VaNavbar class="app-layout-navbar py-3 px-0 glass-panel">
    <template #left>
      <div class="left flex items-center">
        <Transition v-if="isMobile" name="icon-fade" mode="out-in">
          <VaIcon
            color="primary"
            :name="isSidebarMinimized ? 'menu' : 'close'"
            size="24px"
            class="mr-4 cursor-pointer hover:scale-110 transition-transform"
            @click="isSidebarMinimized = !isSidebarMinimized"
          />
        </Transition>
        <RouterLink to="/" aria-label="Visit home page" class="flex items-center group">
          <div class="nexacon-logo mr-4 flex items-center">
            <div class="logo-box p-1 transition-transform group-hover:scale-105">
              <img src="/images/logos/nexacon-icon.svg" alt="Nexacon Logo" class="h-8 w-8" />
            </div>
            <span
              class="ml-2 text-xl font-extrabold tracking-tighter text-slate-800 dark:text-slate-100 hidden sm:block"
            >
              Nexa<span class="text-primary">Conn</span>
            </span>
          </div>
        </RouterLink>
      </div>
    </template>
    <template #center>
      <div class="search-bar-wrapper hidden lg:flex items-center w-full max-w-lg mx-auto">
        <VaInput
          v-model="searchQuery"
          placeholder="Command search (⌘ + K)"
          class="w-full premium-search-input"
          size="medium"
          clearable
        >
          <template #prependInner>
            <VaIcon name="mso-search" color="secondary" size="20px" />
          </template>
        </VaInput>
      </div>
    </template>
    <template #right>
      <AppNavbarActions class="app-navbar__actions pr-4" :is-mobile="isMobile" />
    </template>
  </VaNavbar>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useGlobalStore } from '../../stores/global-store'
import AppNavbarActions from './components/AppNavbarActions.vue'

defineProps({
  isMobile: { type: Boolean, default: false },
})

const GlobalStore = useGlobalStore()
const { isSidebarMinimized } = storeToRefs(GlobalStore)

// Search functionality
const searchQuery = ref('')
</script>

<style lang="scss" scoped>
.app-layout-navbar {
  z-index: 100;
  transition: all 0.3s ease;
}

.premium-search-input {
  :deep(.va-input-wrapper) {
    background-color: var(--va-background-element) !important;
    border: 1px solid var(--va-background-border) !important;
    border-radius: 1rem !important;
    padding-inline: 0.75rem !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      border-color: rgba(34, 197, 94, 0.3) !important;
      background-color: var(--va-background-secondary) !important;
    }

    &.va-input-wrapper--focused {
      border-color: var(--va-primary) !important;
      box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.1) !important;
      background-color: var(--va-background-secondary) !important;
      max-width: 110%; // Slight expansion on focus
    }
  }
}

.left {
  margin-left: 1.5rem;
}

.icon-fade-enter-active,
.icon-fade-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.icon-fade-enter-from,
.icon-fade-leave-to {
  opacity: 0;
  transform: scale(0.8) rotate(-15deg);
}
</style>
